import { render, staticRenderFns } from "./purchasing.vue?vue&type=template&id=6428dcaf&scoped=true"
import script from "./purchasing.vue?vue&type=script&lang=js"
export * from "./purchasing.vue?vue&type=script&lang=js"
import style0 from "./purchasing.vue?vue&type=style&index=0&id=6428dcaf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6428dcaf",
  null
  
)

export default component.exports